import React, { useEffect, useState, useRef, useContext } from 'react'
import { fetchConsignorDetailsData, updateConsignorSetting } from '_services/accountsServices/consignorServices';
import { ButtonHeading, CommonCheckbox, CommonInput, Customdropdown, CustomSelect, NavTabs } from 'components'
import { AddButton } from 'components/common/CommonButton';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import StorageService from "utils/StorageServices/StorageServices";
import LoadingBar from 'react-top-loading-bar';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { constant } from 'constants/constant';
import { HiChevronDown } from 'react-icons/hi2';
import { Accordion } from 'react-bootstrap';
import { UserContext } from 'context';
import { getUser } from '_services';
import { utils } from 'helper';
import './setting.css';


const options = [
    { id: 1, label: 'Alphanumeric', value: 1 },
    { id: 2, label: 'Numeric', value: 2 },
    { id: 3, label: 'Any', value: 3 }
];

const Settings = (props) => {

    let { detailsData } = props;
    const consignorTabs = detailsData?.company?.subscription_data?.company_settings?.find((el) => el?.sort === 6)?.permissions ?? [];

    useDocumentTitle("Setting | T360");
    const navigate = useNavigate();
    let { id } = useParams();
    const loadingBarRef = useRef(null);

    const allKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    const [activeKeys, setActiveKeys] = useState([]);
    const { masterData } = useContext(UserContext);
    const [formatList, setFormatList] = useState([]);

    const [userList, setUserList] = useState([]);

    const toggleAll = () => {
        if (activeKeys.length === allKeys.length) {
            setActiveKeys([]);
        } else {
            setActiveKeys(allKeys);
        }
    };

    const handleToggle = (key) => {
        setActiveKeys((prevKeys) =>
            prevKeys.includes(key)
                ? prevKeys.filter((k) => k !== key)
                : [...prevKeys, key]
        );
    };

    const formObj = {
        company_id: StorageService.getCompanyId(),
        consignor_id: id,
        permission_at_dispatch: {
            lr_mandatory: 0,
            eway_bill_mandatory: 0,
            freight_mandatory: 0
        },
        permission_at_lr: {
            unit_mandatory: 0,
            consignee_mandatory: 0,
            eway_bill_mandatory: 0
        },
        permission_at_invoice_number: {
            view: 0,
            mandatory: 0,
            input_length: 0,
            min: null,
            max: null,
            field_type: 1,
            // field_name: 'Invoice Number',
        },
        permission_at_field2: {
            view: 0,
            mandatory: 0,
            field_name: '',
            input_length: 0,
            min: null,
            max: null,
            field_type: 1,
        },
        permission_at_field3: {
            view: 0,
            mandatory: 0,
            field_name: '',
            input_length: 0,
            min: null,
            max: null,
            field_type: 1,
        },
        permission_at_field4: {
            view: 0,
            mandatory: 0,
            field_name: '',
            input_length: 0,
            min: null,
            max: null,
            field_type: 1,
        },
        permission_at_field5: {
            view: 0,
            mandatory: 0,
            field_name: '',
            input_length: 0,
            min: null,
            max: null,
            field_type: 1,
        },
        permission_at_item: {
            item: {
                view: 1,
                mandatory: 0
            },
            item_desc: {
                view: 1,
                mandatory: 0
            },
            item_group_hsn: {
                view: 1,
                mandatory: 0
            },
            weight: {
                view: 0,
                mandatory: 0
            },
            kot: {
                view: 0,
                mandatory: 0
            },
            sales: {
                view: 0,
                mandatory: 0
            },
            qty: {
                view: 0,
                mandatory: 0
            },
            total_weight_type: 2,
        },
        permission_at_pod: {
            attachment: {
                view: 0,
                mandatory: 0
            },
            pod_number: {
                view: 0,
                mandatory: 0,
                field_name: '',
                input_length: 0,
                min: null,
                max: null,
                field_type: 1,
            }
        },
        permission_at_eway: {
            fetch_items: 0
        },

        permission_at_indent: {
            responses: []
        }
    }

    const [formValue, setFormValue] = useState(formObj);
    const [loading, setLoading] = useState(false);

    const handleStringOnChange = async (name, value, parent_name) => {
        setFormValue((formValue) => ({
            ...formValue,
            [parent_name]: {
                ...formValue[parent_name],
                [name]: value ? value : ''
            }
        }));
    };

    const handleStringOnChange1 = async (name, value, parent_name) => {
        setFormValue((formValue) => ({
            ...formValue,
            [parent_name]: {
                ...formValue[parent_name],
                [name]: value ? +value : null
            }
        }));
    };

    const handlerStringOnChange1OnlyForMinMax = (name, value, parent_name) => {
        let cleanedValue = value.replace(/[^0-9]/g, "");
        let numericValue = cleanedValue ? Number(cleanedValue) : null;
        if (numericValue !== null) {
            if (numericValue < 1) numericValue = 1;
            if (numericValue > 40) numericValue = 40;
        }
        setFormValue((prev) => {
            const parent = prev[parent_name];
            let { min, max } = parent;

            if (name === "min") {
                min = numericValue;
                if (max !== null && max < min) {
                    max = min;
                }
            }

            if (name === "max") {
                max = numericValue;
                if (min === null || min > max) {
                    min = max;
                }
            }

            return {
                ...prev,
                [parent_name]: {
                    ...parent,
                    min,
                    max,
                },
            };
        });
    };

    // const handleCheckboxChange = (section, key) => (event) => {
    //     setFormValue((formValue) => ({
    //         ...formValue,
    //         [section]: {
    //             ...formValue[section],
    //             [key]: event.target.checked ? 1 : 0
    //         }
    //     }));
    // };

    const handleCheckboxChange = (section, key) => (event) => {
        const checked = event.target.checked ? 1 : 0;

        setFormValue((prev) => {
            const prevSection = prev[section];

            let updatedSection = {
                ...prevSection,
                [key]: checked
            };

            if (key === 'view' && checked === 0) {
                updatedSection = {
                    ...updatedSection,
                    mandatory: 0,
                    unique: 0
                };
            }

            return {
                ...prev,
                [section]: updatedSection
            };
        });
    };


    const checkboxHandlerNestedObject = (first, second, third) => (event) => {
        const newValue = event.target.checked ? 1 : 0;
        setFormValue((prev) => {
            const updated = {
                ...prev,
                [first]: {
                    ...prev[first],
                    [second]: {
                        ...prev[first][second],
                        [third]: newValue,
                    },
                },
            };

            if (first === 'permission_at_item' && third === 'view' && newValue === 0) {
                updated[first][second].mandatory = 0;
            }

            if (first === 'permission_at_item') {
                const allViewValues = Object.values(updated.permission_at_item)
                    .filter((v) => typeof v === 'object' && v !== null && 'view' in v)
                    .map((v) => v.view);

                const hasAnyView1 = allViewValues.some((v) => v === 1);
                updated.permission_at_item_parent = hasAnyView1 ? 1 : 0;
            }

            return updated;
        });
    };

    const handleResponseCheckboxChange = (id) => (event) => {

        setFormValue((prevFormValue) => {
            const currentResponses = prevFormValue.permission_at_indent.responses || [];
            let updatedResponses;

            if (event.target.checked) {
                updatedResponses = currentResponses.includes(id)
                    ? currentResponses
                    : [...currentResponses, id];
            } else {
                updatedResponses = currentResponses.filter(responseId => responseId !== id);
            }

            return {
                ...prevFormValue,
                permission_at_indent: {
                    ...prevFormValue.permission_at_indent,
                    responses: updatedResponses
                }
            };
        });
    };

    const isResponseSelected = (id) => {
        return formValue?.permission_at_indent?.responses?.includes(id);
    };

    const submitSettings = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            let newObj = {
                ...formValue,
                consignor_id: id,
                permission_at_eway: {
                    ...formValue?.permission_at_eway,
                    fetch_items: formValue?.permission_at_eway?.fetch_items != null ? formValue?.permission_at_eway?.fetch_items : 0
                },
                permission_at_invoice_number: {
                    ...formValue.permission_at_invoice_number,
                    // field_type: formValue.permission_at_invoice_number?.field_type ? formValue.permission_at_invoice_number?.field_type : 1,
                    min: formValue.permission_at_invoice_number?.min != null ? formValue.permission_at_invoice_number?.min : 8,
                    max: formValue.permission_at_invoice_number?.max != null ? formValue.permission_at_invoice_number?.max : 12,
                },
                permission_at_field2: {
                    ...formValue.permission_at_field2,
                    min: formValue.permission_at_field2?.min != null ? formValue.permission_at_field2?.min : 8,
                    max: formValue.permission_at_field2?.max != null ? formValue.permission_at_field2?.max : 12,
                },
                permission_at_field3: {
                    ...formValue.permission_at_field3,
                    min: formValue.permission_at_field3?.min != null ? formValue.permission_at_field3?.min : 8,
                    max: formValue.permission_at_field3?.max != null ? formValue.permission_at_field3?.max : 12,
                },
                permission_at_field4: {
                    ...formValue.permission_at_field4,
                    min: formValue.permission_at_field4?.min != null ? formValue.permission_at_field4?.min : 8,
                    max: formValue.permission_at_field4?.max != null ? formValue.permission_at_field4?.max : 12,
                },
                permission_at_field5: {
                    ...formValue.permission_at_field5,
                    min: formValue.permission_at_field5?.min != null ? formValue.permission_at_field5?.min : 8,
                    max: formValue.permission_at_field5?.max != null ? formValue.permission_at_field5?.max : 12,
                },
                permission_at_pod: {
                    ...formValue.permission_at_pod,
                    pod_number: {
                        ...formValue.permission_at_pod.pod_number,
                        view: formValue.permission_at_pod.pod_number?.view != null ? formValue.permission_at_pod.pod_number?.view : 0,
                        mandatory: formValue.permission_at_pod.pod_number?.mandatory != null ? formValue.permission_at_pod.pod_number?.mandatory : 0,
                        min: formValue.permission_at_pod.pod_number?.min != null ? formValue.permission_at_pod.pod_number?.min : 8,
                        max: formValue.permission_at_pod.pod_number?.max != null ? formValue.permission_at_pod.pod_number?.max : 12,
                    }
                },
                permission_at_item: {
                    ...formValue.permission_at_item,
                    total_weight_type: formValue.permission_at_item.total_weight_type ? formValue.permission_at_item.total_weight_type : 2,
                    item: formValue.permission_at_item.item ? formValue.permission_at_item.item : {
                        view: 1,
                        mandatory: 0,
                    },
                    item_desc: formValue.permission_at_item.item_desc ? formValue.permission_at_item.item_desc : {
                        view: 1,
                        mandatory: 0,
                    },
                    item_group_hsn: formValue.permission_at_item.item_group_hsn ? formValue.permission_at_item.item_group_hsn : {
                        view: 1,
                        mandatory: 0,
                    },
                },
                permission_at_item_parent: formValue?.permission_at_item_parent,
                freight_visibility: formValue?.freight_visibility ? formValue?.freight_visibility : {}
            }

            const res = await updateConsignorSetting(newObj);
            if (res?.responseCode == 200) {
                toast.success(`Settings Update`);
                setLoading(false);
            } else {
                toast.error('Something went wrong, Settings Not Updated');
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            toast.error('Something went wrong, Settings Not Updated');
        }
    }

    const getDataConsignorDetails = async (id_1, id_2) => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                consignor_id: id_1,
                company_id: id_2,
            }
            const res = await fetchConsignorDetailsData(object);
            if (res?.responseCode == 200) {
                let data = res?.data?.consignor;
                let companyDetails = res?.data?.company;
                if (companyDetails?.invoice_formats?.length) {
                    setFormatList(companyDetails?.invoice_formats.map((i) => ({ ...i, label: i?.name, value: i?._id })))
                }
                setFormValue((s) => ({
                    ...s,
                    invoice_format_id: data?.invoice_format_id,
                    permission_at_dispatch: data.permission_at_dispatch,
                    permission_at_lr: data.permission_at_lr,
                    permission_at_invoice_number: data.permission_at_invoice_number,
                    permission_at_field2: data.permission_at_field2,
                    permission_at_field3: data.permission_at_field3,
                    permission_at_field4: data.permission_at_field4,
                    permission_at_field5: data.permission_at_field5,
                    permission_at_item: {
                        ...data.permission_at_item,
                        item: data.permission_at_item.item ? data.permission_at_item.item : {
                            view: 1,
                            mandatory: 0,
                        },
                        item_desc: data.permission_at_item.item_desc ? data.permission_at_item.item_desc : {
                            view: 1,
                            mandatory: 0,
                        },
                        item_group_hsn: data.permission_at_item.item_group_hsn ? data.permission_at_item.item_group_hsn : {
                            view: 1,
                            mandatory: 0,
                        },
                        total_weight_type: data.permission_at_item.total_weight_type ? data.permission_at_item.total_weight_type : 2
                    },
                    permission_at_pod: data.permission_at_pod,
                    permission_at_eway: data.permission_at_eway ? data.permission_at_eway : { fetch_items: 0 },
                    permission_at_indent: {
                        ...s.permission_at_indent,
                        ...data.permission_at_indent,
                        responses: data?.permission_at_indent?.responses || []
                    },
                    permission_at_item_parent: data?.permission_at_item_parent ? data?.permission_at_item_parent : 0,
                    freight_visibility: data?.freight_visibility ? data?.freight_visibility : {},
                    is_auto_message: data?.is_auto_message ? data?.is_auto_message : false,
                }))
            }
        } catch (error) {
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    const getUserList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                limit: 5000,
                offset: 1,
                search: "",
                status: "",
            };
            const res = await getUser(object);
            if (res?.responseCode == 200) {
                const list = res.data?.user_list.map((i) => {
                    return {
                        ...i,
                        label: i.company_user_name,
                        value: i.user_id,
                    };
                });
                setUserList(list);
            }
        } catch (error) {
            // throw error;
        }
    };

    useEffect(() => {
        if (id && StorageService.getCompanyId()) {
            getUserList();
            getDataConsignorDetails(id, StorageService.getCompanyId());
        }
    }, [id, StorageService.getCompanyId()])

    const handleNestedInput = (first, second, third, fieldValue) => {
        setFormValue((formValue) => ({
            ...formValue,
            [first]: {
                ...formValue[first],
                [second]: {
                    ...formValue[first][second],
                    [third]: fieldValue ? fieldValue : '',
                }
            }
        }));
    };

    const handleNestedMinMaxInput = (first, second, third, fieldValue) => {
        setFormValue((formValue) => ({
            ...formValue,
            [first]: {
                ...formValue[first],
                [second]: {
                    ...formValue[first][second],
                    [third]: fieldValue ? +fieldValue : null,
                }
            }
        }));
    };

    const handleNestedDropdown = (first, second, third, value) => {
        setFormValue((formValue) => ({
            ...formValue,
            [first]: {
                ...formValue[first],
                [second]: {
                    ...formValue[first][second],
                    [third]: value,
                }
            }
        }));
    };

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        if (name === 'permission_at_item_parent' && !value) {
            const updatedPermissionAtItem = {
                ...stateObj.permission_at_item,
                item: { ...stateObj.permission_at_item.item, view: 0, mandatory: 0 },
                item_desc: { ...stateObj.permission_at_item.item_desc, view: 0, mandatory: 0 },
                item_group_hsn: { ...stateObj.permission_at_item.item_group_hsn, view: 0, mandatory: 0 },
                weight: { ...stateObj.permission_at_item.weight, view: 0, mandatory: 0 },
                kot: { ...stateObj.permission_at_item.kot, view: 0, mandatory: 0 },
                sales: { ...stateObj.permission_at_item.sales, view: 0, mandatory: 0 },
                qty: { ...stateObj.permission_at_item.qty, view: 0, mandatory: 0 },
                total_weight_type: stateObj.permission_at_item.total_weight_type, // keep as is
            };

            stateObj.permission_at_item = updatedPermissionAtItem;
        }
        if (name === 'permission_at_item_parent' && value) {
            const updatedPermissionAtItem = {
                ...stateObj.permission_at_item,
                item: { ...stateObj.permission_at_item.item, view: 1, mandatory: 0 },
                item_desc: { ...stateObj.permission_at_item.item_desc, view: 1, mandatory: 0 },
                item_group_hsn: { ...stateObj.permission_at_item.item_group_hsn, view: 1, mandatory: 0 },
                weight: { ...stateObj.permission_at_item.weight, view: 1, mandatory: 0 },
                kot: { ...stateObj.permission_at_item.kot, view: 1, mandatory: 0 },
                sales: { ...stateObj.permission_at_item.sales, view: 1, mandatory: 0 },
                qty: { ...stateObj.permission_at_item.qty, view: 1, mandatory: 0 },
                total_weight_type: stateObj.permission_at_item.total_weight_type, // keep as is
            };

            stateObj.permission_at_item = updatedPermissionAtItem;
        }
        setFormValue(stateObj);
    };

    // const handleListUpdate = async (userId, name, value) => {
    //     setFormValue((formValue) => {
    //         const freight_visibility = { ...formValue.freight_visibility };
    //         if (freight_visibility[userId]) {
    //             freight_visibility[userId] = {
    //                 ...freight_visibility[userId],
    //                 [name]: value,
    //             };
    //         } else {
    //             freight_visibility[userId] = { [name]: value };
    //         }

    //         return {
    //             ...formValue,
    //             freight_visibility,
    //         };
    //     });
    // };

    const handleListUpdate = (userId, name, value) => {
        setFormValue((prev) => {
            const updatedFreight = { ...prev.freight_visibility };

            userList.forEach((user) => {
                const id = user?.user_id?._id;
                if (!updatedFreight[id]) {
                    updatedFreight[id] = { visibility: 0 };
                }
            });

            updatedFreight[userId] = {
                ...updatedFreight[userId],
                [name]: value,
            };

            return {
                ...prev,
                freight_visibility: updatedFreight,
            };
        });
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "available":
                return "success";
            case "not_available":
                return "danger";
            case "premium":
                return "warning";
            case "coming_soon":
                return "info";
            default:
                return "secondary";
        }
    };

    const getText = (status) => {
        switch (status) {
            case "available":
                return "";
            case "not_available":
                return "Not Available";
            case "premium":
                return "Premium";
            case "coming_soon":
                return "Coming Soon";
            default:
                return "";
        }
    };

    const statusFunction = (object) => {
        for (let key in object) {
            let statusKey = ["available", "not_available", "premium", "coming_soon", "full_access"]
            if (statusKey.includes(key) && object[key] === 1) {
                return key;
            }
        }
    }

    return (
        <>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />

            <div className='__stMain'>

                <div className='__stContent'>

                    <div className='__setf_brancOtr'>

                        <div className='__setf_brancInner' style={{minWidth: '1100px', width: '100%'}}>
                            <div className='__setf_brancBx'>
                                <div className='__setf_brHead'>
                                    <h4>Settings</h4>
                                    {consignorTabs?.every((el) => el?.web === 1) ? <span onClick={toggleAll}>
                                        <HiChevronDown style={{ transform: activeKeys.length === allKeys.length ? "rotate(180deg)" : "rotate(0deg)", transition: '0.3s' }} />
                                    </span> : <></>}
                                </div>

                                <Accordion className='__setingAccordian' activeKey={activeKeys} alwaysOpen>

                                    {consignorTabs[0]?.not_available !== 1 ? <Accordion.Item eventKey="0">
                                        <Accordion.Header
                                            onClick={() => {
                                                if (consignorTabs[0]?.available === 1 && consignorTabs[0]?.web === 1) {
                                                    handleToggle("0")
                                                }
                                            }}
                                            style={{
                                                opacity: (consignorTabs[0]?.available !== 1 && consignorTabs[0]?.web !== 1) ? 0.5 : 1,
                                                cursor: (consignorTabs[0]?.available !== 1 && consignorTabs[0]?.web !== 1) ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            PERMISSION AT DISPATCH TRIP
                                            <span
                                                className={`badge bg-${getStatusColor(statusFunction(consignorTabs[0]))}`}
                                                style={{
                                                    marginLeft: "10px",
                                                    padding: "5px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {getText(statusFunction(consignorTabs[0]))}
                                            </span>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <div className='__setf_branc_sepBx'>
                                                <div className='_brxFlex'>
                                                    <div className='_dLass'>
                                                        <CommonCheckbox
                                                            type="checkbox"
                                                            name="Add LR Mandatory "
                                                            id='lr_mandatory'
                                                            isChecked={formValue?.permission_at_dispatch?.lr_mandatory === 1}
                                                            handleClick={handleCheckboxChange('permission_at_dispatch', 'lr_mandatory')}
                                                        />
                                                    </div>

                                                    <div className='_dLass'>
                                                        <CommonCheckbox
                                                            type="checkbox"
                                                            name="Add Eway Bill Mandatory"
                                                            id="eway_bill_mandatory_dispatch"
                                                            isChecked={formValue?.permission_at_dispatch?.eway_bill_mandatory === 1}
                                                            handleClick={handleCheckboxChange('permission_at_dispatch', 'eway_bill_mandatory')}
                                                        />
                                                    </div>

                                                    <div className='_dLass'>
                                                        <CommonCheckbox
                                                            type="checkbox"
                                                            name="Add Freight Mandatory"
                                                            id="freight_mandatory"
                                                            isChecked={formValue?.permission_at_dispatch?.freight_mandatory === 1}
                                                            handleClick={handleCheckboxChange('permission_at_dispatch', 'freight_mandatory')}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item> : <></>}

                                    {consignorTabs[1]?.not_available !== 1 ? <Accordion.Item eventKey="1">
                                        <Accordion.Header
                                            onClick={() => {
                                                if (consignorTabs[1]?.available === 1 && consignorTabs[1]?.web === 1) {
                                                    handleToggle("1")
                                                }
                                            }}
                                            style={{
                                                opacity: (consignorTabs[1]?.available !== 1 && consignorTabs[1]?.web !== 1) ? 0.5 : 1,
                                                cursor: (consignorTabs[1]?.available !== 1 && consignorTabs[1]?.web !== 1) ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            PERMISSION AT ADD LR
                                            <span
                                                className={`badge bg-${getStatusColor(statusFunction(consignorTabs[1]))}`}
                                                style={{
                                                    marginLeft: "10px",
                                                    padding: "5px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {getText(statusFunction(consignorTabs[1]))}
                                            </span>
                                        </Accordion.Header>
                                        {/* <Accordion.Header
                                            onClick={() => handleToggle("1")}
                                        >
                                            PERMISSION AT ADD LR
                                        </Accordion.Header> */}
                                        <Accordion.Body>
                                            <div className='__setf_branc_sepBx'>
                                                <div className='_brxFlex'>
                                                    <div className='_dLass'>
                                                        <CommonCheckbox
                                                            type="checkbox"
                                                            name="Add Unit Mandatory"
                                                            id="unit_mandatory"
                                                            isChecked={formValue?.permission_at_lr?.unit_mandatory === 1}
                                                            handleClick={handleCheckboxChange('permission_at_lr', 'unit_mandatory')}
                                                        />
                                                    </div>

                                                    <div className='_dLass'>
                                                        <CommonCheckbox
                                                            type="checkbox"
                                                            name="Add Consignee Mandatory"
                                                            id="consignee_mandatory"
                                                            isChecked={formValue?.permission_at_lr?.consignee_mandatory === 1}
                                                            handleClick={handleCheckboxChange('permission_at_lr', 'consignee_mandatory')}
                                                        />
                                                    </div>

                                                    <div className='_dLass'>
                                                        <CommonCheckbox
                                                            type="checkbox"
                                                            name='Add Eway Bill Mandatory'
                                                            id='eway_bill_mandatory'
                                                            isChecked={formValue?.permission_at_lr?.eway_bill_mandatory === 1}
                                                            handleClick={handleCheckboxChange('permission_at_lr', "eway_bill_mandatory")}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item> : <></>}

                                    {consignorTabs[2]?.not_available !== 1 ? <Accordion.Item eventKey="2">
                                        <Accordion.Header
                                            onClick={() => {
                                                if (consignorTabs[2]?.available === 1 && consignorTabs[2]?.web === 1) {
                                                    handleToggle("2")
                                                }
                                            }}
                                            style={{
                                                opacity: (consignorTabs[2]?.available !== 1 && consignorTabs[2]?.web !== 1) ? 0.5 : 1,
                                                cursor: (consignorTabs[2]?.available !== 1 && consignorTabs[2]?.web !== 1) ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            CUSTOM FIELD AT ADD LR
                                            <span
                                                className={`badge bg-${getStatusColor(statusFunction(consignorTabs[2]))}`}
                                                style={{
                                                    marginLeft: "10px",
                                                    padding: "5px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {getText(statusFunction(consignorTabs[2]))}
                                            </span>
                                        </Accordion.Header>
                                        {/* <Accordion.Header onClick={() => handleToggle("2")}>CUSTOM FIELD AT ADD LR</Accordion.Header> */}
                                        <Accordion.Body>
                                            <div className='__setf_branc_table'>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>Fields</th>
                                                            <th>Permission</th>
                                                            <th>Field Name</th>
                                                            <th>Field Size</th>
                                                            <th>Field Type</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Invoice Number</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id='invoice_view'
                                                                            isChecked={formValue?.permission_at_invoice_number?.view === 1}
                                                                            handleClick={handleCheckboxChange('permission_at_invoice_number', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="invoice_mandatory"
                                                                            disabled={!formValue?.permission_at_invoice_number?.view}
                                                                            isChecked={formValue?.permission_at_invoice_number?.mandatory}
                                                                            handleClick={handleCheckboxChange('permission_at_invoice_number', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Unique"
                                                                            id="unique"
                                                                            disabled={!formValue?.permission_at_invoice_number?.view}
                                                                            isChecked={formValue?.permission_at_invoice_number?.unique}
                                                                            handleClick={handleCheckboxChange('permission_at_invoice_number', 'unique')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='_divFix_wid'>
                                                                    <CommonInput
                                                                        type="text"
                                                                        placeholder="Invoice Number"
                                                                        label="Invoice Number"
                                                                        name="Invoice Number"
                                                                        disabled
                                                                        value='Invoice Number'
                                                                    // onChange={({ target: { name, value } }) =>
                                                                    //     handleStringOnChange(name, value, 'permission_at_invoice_number')
                                                                    // }
                                                                    />
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className='_divFix_wid _brxFlex'>
                                                                    <div className='halfDiv'>
                                                                        {/* <CommonInput
                                                                            type="number"
                                                                            placeholder="Minimum Size"
                                                                            label="Min Size"
                                                                            name="min"
                                                                            min={15}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_invoice_number?.min}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handleStringOnChange1(name, value, 'permission_at_invoice_number')
                                                                            }
                                                                        /> */}
                                                                        <CommonInput
                                                                            type="number"
                                                                            placeholder="Minimum Size"
                                                                            label="Min Size"
                                                                            name="min"
                                                                            min={1}
                                                                            max={40}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_invoice_number?.min}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handlerStringOnChange1OnlyForMinMax(name, value, 'permission_at_invoice_number')
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className='halfDiv'>
                                                                        {/* <CommonInput
                                                                            type="number"
                                                                            placeholder="Maximum Size"
                                                                            label="Max Size"
                                                                            name="max"
                                                                            max={40}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_invoice_number?.max}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handleStringOnChange1(name, value, 'permission_at_invoice_number')
                                                                            }
                                                                        /> */}
                                                                        <CommonInput
                                                                            type="number"
                                                                            placeholder="Maximum Size"
                                                                            label="Max Size"
                                                                            name="max"
                                                                            min={1}
                                                                            max={40}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_invoice_number?.max}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handlerStringOnChange1OnlyForMinMax(name, value, 'permission_at_invoice_number')
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className='_divFix_wid' style={{ maxWidth: '225px' }}>
                                                                    <CustomSelect
                                                                        name="fieldSix"
                                                                        options={options}
                                                                        label='Type'
                                                                        value={options?.find((el) => el?.value === formValue?.permission_at_invoice_number?.field_type)}
                                                                        onSelect={(option) => handleStringOnChange('field_type', option?.value, 'permission_at_invoice_number')}
                                                                        placeholder="Select an option"
                                                                        disableSearch={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>Field 2</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="field2_view"
                                                                            isChecked={formValue?.permission_at_field2?.view}
                                                                            handleClick={handleCheckboxChange('permission_at_field2', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="field2_mandatory"
                                                                            disabled={!formValue?.permission_at_field2?.view}
                                                                            isChecked={formValue?.permission_at_field2?.mandatory}
                                                                            handleClick={handleCheckboxChange('permission_at_field2', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Unique"
                                                                            id="field2_unique"
                                                                            disabled={!formValue?.permission_at_field2?.view}
                                                                            isChecked={formValue?.permission_at_field2?.unique}
                                                                            handleClick={handleCheckboxChange('permission_at_field2', 'unique')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='_divFix_wid'>
                                                                    <CommonInput
                                                                        type="text"
                                                                        placeholder="Field Name"
                                                                        label="Field Name"
                                                                        name="field_name"
                                                                        value={formValue?.permission_at_field2?.field_name}
                                                                        onChange={({ target: { name, value } }) =>
                                                                            handleStringOnChange(name, value, 'permission_at_field2')
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className='_divFix_wid _brxFlex'>
                                                                    <div className='halfDiv'>
                                                                        <CommonInput
                                                                            type="number"
                                                                            placeholder="Minimum Size"
                                                                            label="Min Size"
                                                                            name="min"
                                                                            min={1}
                                                                            max={40}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_field2?.min}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handlerStringOnChange1OnlyForMinMax(name, value, 'permission_at_field2')
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className='halfDiv'>
                                                                        <CommonInput
                                                                            type="number"
                                                                            placeholder="Maximum Size"
                                                                            label="Max Size"
                                                                            name="max"
                                                                            min={1}
                                                                            max={40}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_field2?.max}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handlerStringOnChange1OnlyForMinMax(name, value, 'permission_at_field2')
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className='_divFix_wid' style={{ maxWidth: '225px' }}>
                                                                    <CustomSelect
                                                                        name="fieldSix"
                                                                        options={options}
                                                                        label='Type'
                                                                        value={options?.find((el) => el?.value === formValue?.permission_at_field2?.field_type)}
                                                                        onSelect={(option) => handleStringOnChange('field_type', option?.value, 'permission_at_field2')}
                                                                        placeholder="Select an option"
                                                                        disableSearch={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>Field 3</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="field3_view"
                                                                            isChecked={formValue?.permission_at_field3?.view}
                                                                            handleClick={handleCheckboxChange('permission_at_field3', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="field3_mandatory"
                                                                            disabled={!formValue?.permission_at_field3?.view}
                                                                            isChecked={formValue?.permission_at_field3?.mandatory}
                                                                            handleClick={handleCheckboxChange('permission_at_field3', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Unique"
                                                                            id="field3_unique"
                                                                            disabled={!formValue?.permission_at_field3?.view}
                                                                            isChecked={formValue?.permission_at_field3?.unique}
                                                                            handleClick={handleCheckboxChange('permission_at_field3', 'unique')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='_divFix_wid'>
                                                                    <CommonInput
                                                                        type="text"
                                                                        placeholder="Field Name"
                                                                        label="Field Name"
                                                                        name="field_name"
                                                                        value={formValue?.permission_at_field3?.field_name}
                                                                        onChange={({ target: { name, value } }) =>
                                                                            handleStringOnChange(name, value, 'permission_at_field3')
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='_divFix_wid _brxFlex'>
                                                                    <div className='halfDiv'>
                                                                        <CommonInput
                                                                            type="number"
                                                                            placeholder="Minimum Size"
                                                                            label="Min Size"
                                                                            name="min"
                                                                            min={1}
                                                                            max={40}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_field3?.min}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handlerStringOnChange1OnlyForMinMax(name, value, 'permission_at_field3')
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className='halfDiv'>
                                                                        <CommonInput
                                                                            type="number"
                                                                            placeholder="Maximum Size"
                                                                            label="Max Size"
                                                                            name="max"
                                                                            min={1}
                                                                            max={40}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_field3?.max}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handlerStringOnChange1OnlyForMinMax(name, value, 'permission_at_field3')
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='_divFix_wid' style={{ maxWidth: '225px' }}>
                                                                    <CustomSelect
                                                                        name="fieldSix"
                                                                        options={options}
                                                                        label='Type'
                                                                        value={options?.find((el) => el?.value === formValue?.permission_at_field3?.field_type)}
                                                                        onSelect={(option) => handleStringOnChange('field_type', option?.value, 'permission_at_field3')}
                                                                        placeholder="Select an option"
                                                                        disableSearch={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>Field 4</td>

                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="field4_view"
                                                                            isChecked={formValue?.permission_at_field4?.view}
                                                                            handleClick={handleCheckboxChange('permission_at_field4', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="field4_mandatory"
                                                                            disabled={!formValue?.permission_at_field4?.view}
                                                                            isChecked={formValue?.permission_at_field4?.mandatory}
                                                                            handleClick={handleCheckboxChange('permission_at_field4', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Unique"
                                                                            id="field4_unique"
                                                                            disabled={!formValue?.permission_at_field4?.view}
                                                                            isChecked={formValue?.permission_at_field4?.unique}
                                                                            handleClick={handleCheckboxChange('permission_at_field4', 'unique')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className='_divFix_wid'>
                                                                    <CommonInput
                                                                        type="text"
                                                                        placeholder="Field Name"
                                                                        label="Field Name"
                                                                        name="field_name"
                                                                        value={formValue?.permission_at_field4?.field_name}
                                                                        onChange={({ target: { name, value } }) =>
                                                                            handleStringOnChange(name, value, 'permission_at_field4')
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className='_divFix_wid _brxFlex'>
                                                                    <div className='halfDiv'>
                                                                        <CommonInput
                                                                            type="number"
                                                                            placeholder="Minimum Size"
                                                                            label="Min Size"
                                                                            name="min"
                                                                            min={1}
                                                                            max={40}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_field4?.min}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handlerStringOnChange1OnlyForMinMax(name, value, 'permission_at_field4')
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className='halfDiv'>
                                                                        <CommonInput
                                                                            type="number"
                                                                            placeholder="Maximum Size"
                                                                            label="Max Size"
                                                                            name="max"
                                                                            min={1}
                                                                            max={40}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_field4?.max}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handlerStringOnChange1OnlyForMinMax(name, value, 'permission_at_field4')
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className='_divFix_wid' style={{ maxWidth: '225px' }}>
                                                                    <CustomSelect
                                                                        name="fieldSix"
                                                                        options={options}
                                                                        label='Type'
                                                                        value={options?.find((el) => el?.value === formValue?.permission_at_field4?.field_type)}
                                                                        onSelect={(option) => handleStringOnChange('field_type', option?.value, 'permission_at_field4')}
                                                                        placeholder="Select an option"
                                                                        disableSearch={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>Field 5</td>

                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="field5_view"
                                                                            isChecked={formValue?.permission_at_field5?.view}
                                                                            handleClick={handleCheckboxChange('permission_at_field5', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="field5_mandatory"
                                                                            disabled={!formValue?.permission_at_field5?.view}
                                                                            isChecked={formValue?.permission_at_field5?.mandatory}
                                                                            handleClick={handleCheckboxChange('permission_at_field5', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Unique"
                                                                            id="field5_unique"
                                                                            disabled={!formValue?.permission_at_field5?.view}
                                                                            isChecked={formValue?.permission_at_field5?.unique}
                                                                            handleClick={handleCheckboxChange('permission_at_field5', 'unique')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className='_divFix_wid'>
                                                                    <CommonInput
                                                                        type="text"
                                                                        placeholder="Field Name"
                                                                        label="Field Name"
                                                                        name="field_name"
                                                                        value={formValue?.permission_at_field5?.field_name}
                                                                        onChange={({ target: { name, value } }) =>
                                                                            handleStringOnChange(name, value, 'permission_at_field5')
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className='_divFix_wid _brxFlex'>
                                                                    <div className='halfDiv'>
                                                                        <CommonInput
                                                                            type="number"
                                                                            placeholder="Minimum Size"
                                                                            label="Min Size"
                                                                            name="min"
                                                                            min={1}
                                                                            max={40}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_field5?.min}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handlerStringOnChange1OnlyForMinMax(name, value, 'permission_at_field5')
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className='halfDiv'>
                                                                        <CommonInput
                                                                            type="number"
                                                                            placeholder="Maximum Size"
                                                                            label="Max Size"
                                                                            name="max"
                                                                            min={1}
                                                                            max={40}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_field5?.max}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handlerStringOnChange1OnlyForMinMax(name, value, 'permission_at_field5')
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className='_divFix_wid' style={{ maxWidth: '225px' }}>
                                                                    <CustomSelect
                                                                        name="fieldSix"
                                                                        options={options}
                                                                        label='Type'
                                                                        value={options?.find((el) => el?.value === formValue?.permission_at_field5?.field_type)}
                                                                        onSelect={(option) => handleStringOnChange('field_type', option?.value, 'permission_at_field5')}
                                                                        placeholder="Select an option"
                                                                        disableSearch={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item> : <></>}

                                    {consignorTabs[3]?.not_available !== 1 ? <Accordion.Item eventKey="3">
                                        <Accordion.Header
                                            onClick={() => {
                                                if (consignorTabs[3]?.available === 1 && consignorTabs[3]?.web === 1) {
                                                    handleToggle("3")
                                                }
                                            }}
                                            style={{
                                                opacity: (consignorTabs[3]?.available !== 1 && consignorTabs[3]?.web !== 1) ? 0.5 : 1,
                                                cursor: (consignorTabs[3]?.available !== 1 && consignorTabs[3]?.web !== 1) ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            PERMISSION AT LR ITEM
                                            <span
                                                className={`badge bg-${getStatusColor(statusFunction(consignorTabs[3]))}`}
                                                style={{
                                                    marginLeft: "10px",
                                                    padding: "5px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {getText(statusFunction(consignorTabs[3]))}
                                            </span>
                                        </Accordion.Header>
                                        {/* <Accordion.Header onClick={() => handleToggle("3")}>PERMISSION AT LR ITEM</Accordion.Header> */}
                                        <Accordion.Body>
                                            <div className='__setf_branc_table'>
                                                <table>
                                                    <thead></thead>

                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: '1.5%' }}>PERMISSION AT LR ITEM</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Permission at lr item"
                                                                            id="permission_at_item_parent"
                                                                            isChecked={formValue?.permission_at_item_parent}
                                                                            handleClick={(e) => handleOnChange("permission_at_item_parent", e.target.checked ? 1 : 0)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '1.5%' }}>Fields</th>
                                                            <th>Permission</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: '1.5%' }}>Item</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="item_view"
                                                                            // isChecked={true}
                                                                            disabled={!formValue?.permission_at_item_parent}
                                                                            isChecked={formValue?.permission_at_item?.item?.view}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'item', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="item_mandatory"
                                                                            disabled={!formValue?.permission_at_item_parent || !formValue?.permission_at_item?.item?.view}
                                                                            isChecked={formValue?.permission_at_item?.item?.mandatory}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'item', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ width: '1.5%' }}>Group HSN</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="item_group_hsn_view"
                                                                            // isChecked={true}
                                                                            // disabled={true}
                                                                            disabled={!formValue?.permission_at_item_parent}
                                                                            isChecked={formValue?.permission_at_item?.item_group_hsn?.view}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'item_group_hsn', 'view')}
                                                                        />

                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="item_group_hsn_mandatory"
                                                                            disabled={!formValue?.permission_at_item_parent || !formValue?.permission_at_item?.item_group_hsn?.view}
                                                                            isChecked={formValue?.permission_at_item?.item_group_hsn?.mandatory}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'item_group_hsn', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        {/* <tr>
                                                            <td style={{ width: '1.5%' }}>HSN</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="item_group_hsn_view"
                                                                            isChecked={true}
                                                                            disabled={true}
                                                                        // isChecked={formValue?.permission_at_item?.item_group_hsn?.view}
                                                                        // handleClick={checkboxHandlerNestedObject('permission_at_item', 'item_group_hsn', 'view')}
                                                                        />

                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="item_group_hsn_mandatory"
                                                                            isChecked={formValue?.permission_at_item?.item_group_hsn?.mandatory}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'item_group_hsn', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr> */}

                                                        <tr>
                                                            <td style={{ width: '1.5%' }}>Item Description</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="item_desc_view"
                                                                            disabled={!formValue?.permission_at_item_parent}
                                                                            isChecked={formValue?.permission_at_item?.item_desc?.view}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'item_desc', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="item_desc_mandatory"
                                                                            disabled={!formValue?.permission_at_item_parent || !formValue?.permission_at_item?.item_desc?.view}
                                                                            isChecked={formValue?.permission_at_item?.item_desc?.mandatory}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'item_desc', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ width: '1.5%' }}>Weight</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="weight_view"
                                                                            disabled={!formValue?.permission_at_item_parent}
                                                                            isChecked={formValue?.permission_at_item?.weight?.view}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'weight', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="weight_mandatory"
                                                                            disabled={!formValue?.permission_at_item_parent || !formValue?.permission_at_item?.weight?.view}
                                                                            isChecked={formValue?.permission_at_item?.weight?.mandatory}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'weight', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ width: '1.5%' }}>KOT</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="kot_view"
                                                                            disabled={!formValue?.permission_at_item_parent}
                                                                            isChecked={formValue?.permission_at_item?.kot?.view}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'kot', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="kot_mandatory"
                                                                            disabled={!formValue?.permission_at_item_parent || !formValue?.permission_at_item?.kot?.view}
                                                                            isChecked={formValue?.permission_at_item?.kot?.mandatory}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'kot', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ width: '1.5%' }}>Sales</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="sales_view"
                                                                            disabled={!formValue?.permission_at_item_parent}
                                                                            isChecked={formValue?.permission_at_item?.sales?.view}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'sales', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="sales_mandatory"
                                                                            disabled={!formValue?.permission_at_item_parent || !formValue?.permission_at_item?.sales?.view}
                                                                            isChecked={formValue?.permission_at_item?.sales?.mandatory}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'sales', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ width: '1.5%' }}>QTY</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="qty_view"
                                                                            disabled={!formValue?.permission_at_item_parent}
                                                                            isChecked={formValue?.permission_at_item?.qty?.view}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'qty', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="qty_mandatory"
                                                                            disabled={!formValue?.permission_at_item_parent || !formValue?.permission_at_item?.qty?.view}
                                                                            isChecked={formValue?.permission_at_item?.qty?.mandatory}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_item', 'qty', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ width: '1.5%' }}>Total Weight Type</td>
                                                            <td>
                                                                <div className='checPary_lv gap-5'>
                                                                    {
                                                                        constant.totalWeightType?.map((el, ind) => {
                                                                            return (
                                                                                <React.Fragment key={ind}>
                                                                                    <div className='_dualCheckr_bx'>
                                                                                        <input
                                                                                            className="form-check-input _avPointer"
                                                                                            id={+ind + "total_weight_type" + el?.value}
                                                                                            type="radio"
                                                                                            name="total_weight_type"
                                                                                            checked={Number(formValue?.permission_at_item?.total_weight_type) === Number(el?.value)}
                                                                                            value={formValue?.permission_at_item?.total_weight_type ? formValue?.permission_at_item?.total_weight_type : ""}
                                                                                            onChange={({ target: { name, value } }) =>
                                                                                                handleStringOnChange1(name, el?.value, 'permission_at_item')
                                                                                            }
                                                                                        />
                                                                                        <label htmlFor={+ind + "total_weight_type" + el.value} className="form-check-label" >
                                                                                            {el.label}
                                                                                        </label>
                                                                                    </div>
                                                                                </React.Fragment>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item> : <></>}

                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header onClick={() => handleToggle("4")}>POD SUBMISSION</Accordion.Header>
                                        <Accordion.Body>
                                            <div className='__setf_branc_table'>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>Fields</th>
                                                            <th>Permission</th>
                                                            <th>Field Name</th>
                                                            <th>Field Size</th>
                                                            <th>Field Type</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>POD Number</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="pod_number_view"
                                                                            isChecked={formValue?.permission_at_pod?.pod_number?.view}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_pod', 'pod_number', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="pod_number_mandatory"
                                                                            isChecked={formValue?.permission_at_pod?.pod_number?.mandatory}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_pod', 'pod_number', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='_divFix_wid'>
                                                                    <CommonInput
                                                                        type="text"
                                                                        placeholder="Field Name"
                                                                        label="Field Name"
                                                                        name="field_name"
                                                                        value={formValue?.permission_at_pod?.pod_number?.field_name}
                                                                        onChange={({ target: { name, value } }) =>
                                                                            handleNestedInput('permission_at_pod', 'pod_number', 'field_name', value)
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className='_divFix_wid _brxFlex'>
                                                                    <div className='halfDiv'>
                                                                        <CommonInput
                                                                            type="number"
                                                                            placeholder="Minimum Size"
                                                                            label="Min Size"
                                                                            name="min"
                                                                            min={15}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_pod?.pod_number?.min}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handleNestedMinMaxInput('permission_at_pod', 'pod_number', 'min', value)
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className='halfDiv'>
                                                                        <CommonInput
                                                                            type="number"
                                                                            placeholder="Maximum Size"
                                                                            label="Max Size"
                                                                            name="max"
                                                                            max={40}
                                                                            maxLength="2"
                                                                            onInput={utils.maxLengthCheck}
                                                                            value={formValue?.permission_at_pod?.pod_number?.max}
                                                                            onChange={({ target: { name, value } }) =>
                                                                                handleNestedMinMaxInput('permission_at_pod', 'pod_number', 'max', value)
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className='_divFix_wid' style={{ maxWidth: '225px' }}>
                                                                    <CustomSelect
                                                                        name="fieldSix"
                                                                        options={options}
                                                                        label='Type'
                                                                        value={options?.find((el) => el?.value === formValue?.permission_at_pod?.pod_number?.field_type)}
                                                                        onSelect={(option) => handleNestedDropdown('permission_at_pod', 'pod_number', 'field_type', option?.value)}
                                                                        placeholder="Select an option"
                                                                        disableSearch={true}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>Attachment</td>
                                                            <td>
                                                                <div className='_brxFlex gap-x-4'>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="View"
                                                                            id="attachment_view"
                                                                            isChecked={formValue?.permission_at_pod?.attachment?.view}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_pod', 'attachment', 'view')}
                                                                        />
                                                                    </div>
                                                                    <div className='_dLass min-w-auto'>
                                                                        <CommonCheckbox
                                                                            type="checkbox"
                                                                            name="Mandatory"
                                                                            id="attachment_mandatory"
                                                                            isChecked={formValue?.permission_at_pod?.attachment?.mandatory}
                                                                            handleClick={checkboxHandlerNestedObject('permission_at_pod', 'attachment', 'mandatory')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td></td>

                                                            <td></td>

                                                            <td></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {consignorTabs[4]?.not_available !== 1 ? <Accordion.Item eventKey="5">
                                        <Accordion.Header
                                            onClick={() => {
                                                if (consignorTabs[4]?.available === 1 && consignorTabs[4]?.web === 1) {
                                                    handleToggle("5")
                                                }
                                            }}
                                            style={{
                                                opacity: (consignorTabs[4]?.available !== 1 && consignorTabs[4]?.web !== 1) ? 0.5 : 1,
                                                cursor: (consignorTabs[4]?.available !== 1 && consignorTabs[4]?.web !== 1) ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            INDENT DISPATCH CAN BE DONE ON FOLLOWING STATUS
                                            <span
                                                className={`badge bg-${getStatusColor(statusFunction(consignorTabs[4]))}`}
                                                style={{
                                                    marginLeft: "10px",
                                                    padding: "5px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {getText(statusFunction(consignorTabs[4]))}
                                            </span>
                                        </Accordion.Header>
                                        {/* <Accordion.Header onClick={() => handleToggle("5")}>INDENT DISPATCH CAN BE DONE ON FOLLOWING STATUS</Accordion.Header> */}
                                        <Accordion.Body>
                                            <div className='__setf_branc_table'>
                                                <div className='_srxFlex'>
                                                    {/* <div className='_dLass'>
                                                        <CommonCheckbox
                                                            type="checkbox"
                                                            name="No Response"
                                                            id="no_response"
                                                        // isChecked={formValue?.permission_at_pod?.pod_number?.view}
                                                        // handleClick={checkboxHandlerNestedObject('permission_at_pod', 'pod_number', 'view')}
                                                        />

                                                        
                                                    </div> */}

                                                    {masterData?.plan_responses_list.map((item) => (
                                                        <div key={item.id} className="_dLass">
                                                            <CommonCheckbox
                                                                type="checkbox"
                                                                name={item.name}
                                                                id={item.id}
                                                                isChecked={isResponseSelected(item.id)}
                                                                handleClick={handleResponseCheckboxChange(item.id)}
                                                            />
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item> : <></>}

                                    {consignorTabs[5]?.not_available !== 1 ? <Accordion.Item eventKey="6">
                                        <Accordion.Header
                                            onClick={() => {
                                                if (consignorTabs[5]?.available === 1 && consignorTabs[5]?.web === 1) {
                                                    handleToggle("6")
                                                }
                                            }}
                                            style={{
                                                opacity: (consignorTabs[5]?.available !== 1 && consignorTabs[5]?.web !== 1) ? 0.5 : 1,
                                                cursor: (consignorTabs[5]?.available !== 1 && consignorTabs[5]?.web !== 1) ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            FETCH EWAY BILL
                                            <span
                                                className={`badge bg-${getStatusColor(statusFunction(consignorTabs[5]))}`}
                                                style={{
                                                    marginLeft: "10px",
                                                    padding: "5px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {getText(statusFunction(consignorTabs[5]))}
                                            </span>
                                        </Accordion.Header>
                                        {/* <Accordion.Header onClick={() => handleToggle("6")}>FETCH EWAY BILL</Accordion.Header> */}
                                        <Accordion.Body>
                                            <div className='__setf_branc_table'>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: '1.5%' }}>Fetch Items</td>
                                                            <td>
                                                                <div className='checPary_lv gap-5'>
                                                                    {
                                                                        constant.fetchItems?.map((el, ind) => {
                                                                            return (
                                                                                <React.Fragment key={ind}>
                                                                                    <div className='_dualCheckr_bx'>
                                                                                        <input
                                                                                            className="form-check-input _avPointer"
                                                                                            id={+ind + "fetch_items" + el?.value}
                                                                                            type="radio"
                                                                                            name="fetch_items"
                                                                                            checked={Number(formValue?.permission_at_eway?.fetch_items) === Number(el?.value)}
                                                                                            value={formValue?.permission_at_eway?.fetch_items ? formValue?.permission_at_eway?.fetch_items : ""}
                                                                                            onChange={({ target: { name, value } }) =>
                                                                                                handleStringOnChange1(name, el?.value, 'permission_at_eway')
                                                                                            }
                                                                                        />
                                                                                        <label htmlFor={+ind + "fetch_items" + el.value} className="form-check-label" >
                                                                                            {el.label}
                                                                                        </label>
                                                                                    </div>
                                                                                </React.Fragment>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item> : <></>}

                                    {consignorTabs[6]?.not_available !== 1 ? <Accordion.Item eventKey="7">
                                        <Accordion.Header
                                            onClick={() => {
                                                if (consignorTabs[6]?.available === 1 && consignorTabs[6]?.web === 1) {
                                                    handleToggle("7")
                                                }
                                            }}
                                            style={{
                                                opacity: (consignorTabs[6]?.available !== 1 && consignorTabs[6]?.web !== 1) ? 0.5 : 1,
                                                cursor: (consignorTabs[6]?.available !== 1 && consignorTabs[6]?.web !== 1) ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            INVOICE FORMAT
                                            <span
                                                className={`badge bg-${getStatusColor(statusFunction(consignorTabs[6]))}`}
                                                style={{
                                                    marginLeft: "10px",
                                                    padding: "5px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {getText(statusFunction(consignorTabs[6]))}
                                            </span>
                                        </Accordion.Header>
                                        {/* <Accordion.Header onClick={() => handleToggle("7")}>INVOICE FORMAT</Accordion.Header> */}
                                        <Accordion.Body>
                                            <div className='__setf_branc_table'>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: '1.5%' }}>Default Format</td>
                                                            <td>
                                                                <div className='checPary_lv gap-5'>
                                                                    <div className='__clm_bxs' style={{ width: '187px' }}>
                                                                        <CustomSelect
                                                                            options={formatList}
                                                                            placeholder="Select Format"
                                                                            name="invoice_format_id"
                                                                            label=''
                                                                            value={formatList?.find((i) => i?.value == formValue?.invoice_format_id)}
                                                                            onSelect={(selectedOption) => {
                                                                                handleOnChange(
                                                                                    "invoice_format_id"
                                                                                    , selectedOption.value);
                                                                            }}
                                                                        />
                                                                    </div>

                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item> : <></>}

                                    {consignorTabs[7]?.not_available !== 1 ? <Accordion.Item eventKey="8">
                                        <Accordion.Header
                                            onClick={() => {
                                                if (consignorTabs[7]?.available === 1 && consignorTabs[7]?.web === 1) {
                                                    handleToggle("8")
                                                }
                                            }}
                                            style={{
                                                opacity: (consignorTabs[7]?.available !== 1 && consignorTabs[7]?.web !== 1) ? 0.5 : 1,
                                                cursor: (consignorTabs[7]?.available !== 1 && consignorTabs[7]?.web !== 1) ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            CONTRACT FREIGHT VISIBILITY
                                            <span
                                                className={`badge bg-${getStatusColor(statusFunction(consignorTabs[7]))}`}
                                                style={{
                                                    marginLeft: "10px",
                                                    padding: "5px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {getText(statusFunction(consignorTabs[7]))}
                                            </span>
                                        </Accordion.Header>
                                        {/* <Accordion.Header onClick={() => handleToggle("8")}> CONTRACT FREIGHT VISIBILITY </Accordion.Header> */}
                                        <Accordion.Body>
                                            <div className='__setf_branc_table'>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '1%' }}>User Name</th>
                                                            <th style={{ width: '1%' }}>User Role</th>
                                                            <th style={{ width: '1%', minWidth: '120px' }}>Visible</th>
                                                            <th style={{ width: '1%' }}>Editable</th>
                                                            <th style={{ width: '5%' }}>Not Visible</th>
                                                            <th style={{ width: '5%' }}></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {userList?.filter((el) => el?.active === 1)?.map((item, index) => {
                                                            return (
                                                                <tr key={item?.user_id?._id}>
                                                                    <td style={{ width: '1%' }}>{item?.company_user_name ? item?.company_user_name : '-'}</td>
                                                                    <td style={{ width: '1%' }}>{item?.role_id?.role_name ? item?.role_id?.role_name : '-'}</td>
                                                                    {constant.contractFreight?.map((el, ind) => (
                                                                        <td style={{ width: '1%', minWidth: '120px' }} key={ind}>
                                                                            <div className="_dualCheckr_bx">
                                                                                <input
                                                                                    className="form-check-input _avPointer"
                                                                                    id={`${item?.user_id?._id}_visibility_${el?.value}`}
                                                                                    type="radio"
                                                                                    name={`visibility_${item?.user_id?._id}`}
                                                                                    checked={Number(formValue?.freight_visibility?.[item?.user_id?._id]?.visibility ?? 0) === Number(el?.value)}
                                                                                    // checked={Number(formValue?.freight_visibility?.[item?.user_id?._id]?.visibility) === Number(el?.value)}
                                                                                    value={el?.value}
                                                                                    onChange={() =>
                                                                                        handleListUpdate(item?.user_id?._id, "visibility", el?.value)
                                                                                    }
                                                                                />
                                                                                <label
                                                                                    htmlFor={`${item?.user_id?._id}_visibility_${el?.value}`}
                                                                                    className="form-check-label"
                                                                                >
                                                                                    {el.label}
                                                                                </label>
                                                                            </div>
                                                                        </td>
                                                                    ))}
                                                                    <td></td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item> : <></>}

                                    <Accordion.Item eventKey="9">
                                        <Accordion.Header onClick={() => handleToggle("9")}> AUTO MESSAGE ON TRIP CREATEION </Accordion.Header>
                                        <Accordion.Body>
                                            <div className='__setf_branc_table'>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: '1.5%' }}>Auto Message on Trip Creation</td>
                                                            <td>
                                                                <div className='checPary_lv gap-5'>
                                                                    {
                                                                        constant.tripCreationItems?.map((el, ind) => {
                                                                            return (
                                                                                <React.Fragment key={ind}>
                                                                                    <div className='_dualCheckr_bx'>
                                                                                        <input
                                                                                            className="form-check-input _avPointer"
                                                                                            id={+ind + "is_auto_message" + el?.value}
                                                                                            type="radio"
                                                                                            name="is_auto_message"
                                                                                            checked={Number(formValue?.is_auto_message) === Number(el?.value)}
                                                                                            value={formValue?.is_auto_message ? formValue?.is_auto_message : ""}
                                                                                            onChange={({ target: { name, value } }) =>
                                                                                                setFormValue((s) => ({ ...s, is_auto_message: el?.value }))
                                                                                                // handleStringOnChange1(name, , 'permission_at_eway')
                                                                                            }
                                                                                        />
                                                                                        <label htmlFor={+ind + "is_auto_message" + el.value} className="form-check-label" >
                                                                                            {el.label}
                                                                                        </label>
                                                                                    </div>
                                                                                </React.Fragment>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                </Accordion>
                            </div>
                        </div>

                    </div>
                </div >
                <div className="bottomFix">
                    <AddButton onClick={(e) => submitSettings(e)} name={loading ? 'Loading...' : "Save Changes"} type="button" disabled={loading} />
                    <button className="_cancel_btn" onClick={(e) => navigate(-1)}> Cancel </button>
                </div>
            </div>
        </>
    )
}

export default Settings